import React, {useState} from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

const DeleteModal = (props: any) => {

    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await props.confirmDeleteHandler();
            props.setShowDeleteModal(false);
        } catch (error) {
            console.error('Failed to delete user:', error);
        } finally {
            setLoading(false);
        }
    };

    return(
        <Modal show={props.showModal}>
            <Modal.Body>
                <p>Etes-vous sûr de vouloir supprimer cet élément ?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => props?.setShowDeleteModal(false)}>Annuler</Button>
                <Button variant="danger" disabled={loading} onClick={ handleConfirm }>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Confirmer'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteModal;